<div class="main">
  <div class="navigation">
    <app-nav></app-nav>
  </div>
  <div class="component">
    <router-outlet></router-outlet>
  </div>

  <!-- <div class="audience-note"> -->
    <!-- <div>Independent relocation guidance. Not affiliated with the U.S. Department of Defense.</div> -->
  <!-- </div> -->
</div>